import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import EditMessagesModal from "../modals/admin/EditMessagesModal";
import MessageItem from "./MessageItem";
import { isAdmin, isPermited } from "../../../features/localStorage";

const LeadersMessages = ({ messagesList }: { messagesList: any }) => {
  // const messagesList = useAppSelector(selectMessages);
  //const dispatch = useAppDispatch();

  useEffect(() => {
    // async function fetchMessages() {
    //   await dispatch(GetMessages());
    // }
    // fetchMessages();
  }, []);
  const messageArrayData = messagesList?.slice(0, 3);
  const editMessagelist: any = messageArrayData;
  const handleAddMessage = () => {
    //alert("click")
  };
  //console.log(isPermited(7,3),"isPermited(7,3)")
  return (
    <>
      <Row>
        <Col sm={12}>
          <div
            className="b_shadow"
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              // marginLeft: "15px",
              marginRight: "-10px",
            }}
          >
            <Row>
              <Col sm="auto" style={{ paddingTop: 2 }}>
                <div
                  style={{
                    fontSize: "17px",
                    fontWeight: "bold",
                    fontStretch: "normal",
                  }}
                >
                  <h4 style={{ fontSize: 13 }}>
                    Message from Mahindra leaders
                  </h4>
                </div>
              </Col>
              {isPermited(7, 3) && (
                <Col sm="auto" className="ps-0 ms-auto desk">
                  <EditMessagesModal
                    data={editMessagelist}
                    handleAddMessage={handleAddMessage}
                  />
                  {/* <a> <Image src={Edit} /> EDIT</a> */}
                </Col>
              )}
            </Row>

            {/* {editMessagelist.map((item:any) => {
              return( <MessageItem key={item.id} item={item} />);
            })} */}

            <MessageItem editMessagelist={editMessagelist} />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default LeadersMessages;
